import NormalApis from '@/controllers/NormalApis';
import Env from '@/env';

export default {
  namespaced: true,
  actions: {
    async registerNewUser(context, data) {
      const url = `${Env.baseUrl}/register`;
      return await NormalApis.postApi(url, {}, data)   
      .then(res => res)
      .catch(err => err);
    },
  },
};
